import { addWeeks } from 'date-fns'

//For Safari!
// This function is used to parse the date string from the auction data

// Core parser — returns null on failure instead of defaulting, so callers
// that need to distinguish "genuinely unparseable" from "successfully
// parsed" (e.g. deciding whether a listing is watchlist-eligible) can. Use
// this over parseCustomDate whenever a fallback-to-now value would be wrong
// to act on.
export function tryParseCustomDate(dateString: string): Date | null {
  // Replace the space between the date and time with a "T" to make it ISO 8601 compliant
  const isoDateString = dateString.replace(' ', 'T')

  // Try to parse the date string using the Date constructor
  let date = new Date(isoDateString)

  if (isNaN(date.getTime())) {
    const [datePart, timePart] = dateString.split(' ')

    // Validate split results - invalid date format if either is missing
    if (!datePart || !timePart) {
      console.error(
        'Invalid date string format (missing date or time part):',
        dateString
      )
      return null
    }

    const [year, month, day] = datePart.split('-').map(Number)
    const [hours, minutes, seconds] = timePart.split(':').map(Number)

    // Validate all components exist - invalid date format if any component is missing
    if (
      year === undefined ||
      month === undefined ||
      day === undefined ||
      hours === undefined ||
      minutes === undefined ||
      seconds === undefined
    ) {
      console.error(
        'Invalid date string format (missing component):',
        dateString
      )
      return null
    }

    // Create a new Date object
    date = new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds))
  }

  if (isNaN(date.getTime())) {
    console.error('Invalid date string:', dateString)
    return null
  }

  return date
}

export function parseCustomDate(dateString: string): Date {
  return tryParseCustomDate(dateString) ?? new Date()
}

// listing.dateVisibilityEnds is not currently available on search service;
// this is a placeholder until it is, shared by every watchlist-add entry
// point (LDP button, card heart, bulk actions).
export function getWatchlistDateExpires(endTime: Date): string {
  return addWeeks(endTime, 2).toISOString()
}
